import { gql } from '@apollo/client';
import { categoryFragment } from '../fragments/category';
import { goalFragment } from '../fragments/goal';
import { questFragment } from '../fragments/quest';

export const getQuestsQuery = gql`
    ${categoryFragment}
    ${goalFragment}
    ${questFragment}

    query GetQuests($dueDateFrom: String, $dueDateTo: String, $limit: Float, $startAtId: String) {
        user {
            id
            goalCompletion
            collectedCurrency
        }
        quests(dueDateFrom: $dueDateFrom, dueDateTo: $dueDateTo, limit: $limit, startAtId: $startAtId) {
            ...QuestFields
        }
        categories {
            ...CategoryFields
        }
        goals {
            ...GoalFields
        }
    }
`;

export const getQuestsByCategoryQuery = gql`
    ${goalFragment}
    ${questFragment}

    query GetQuestsByCategory($categoryId: String!) {
        questsByCategory(categoryId: $categoryId, status: "IN_PROGRESS") {
            ...QuestFields
        }
        goals {
            ...GoalFields
        }
    }
`;
